<template>
  <div class="container">
    <div class="bg"></div>
	<!--header-start-->
    <!-- <div class="header" style="display: flex;justify-content: space-between"> -->
      <!-- <div style="width:100%;max-width:1200px;margin:0px auto;"> -->
              <!-- <div class="logo">
        <router-link to="/Login">
          <img src="../assets/logo.png" />
        </router-link>
      </div> -->
<!--      <div class="qh" style="margin-top: 18px;color: white;margin-right: 20px;visibility:hidden">
        <span style="font-size: 12px">
          <span style="padding: 5px;background-color: #1e8bf0;border-radius:3px">当前平台:公共服务</span>
        </span>
        <span style="padding: 3px;background:#60caff;font-size: 12px;">
          <Icon type="md-swap" />企业平台
        </span>
      </div> -->
      <!-- </div> -->
    <!-- </div> -->
	<!--header-end-->
    <div class="ct">
      <div class="img">
        <router-link to="/Login">
          <img src="../assets/fruitages.png" />
        </router-link>
      </div>
      <div class="rt">
        <!-- <div class="name">真源码农产品追溯公共服务平台</div> -->
        <div
          class="wz"
          style="text-align:center;width: 80%;margin: 10px auto;color: white;font-size: 1rem"
        >
          <span>累计溯源:</span>
          <span style="font-size: 1.4rem;color: #F8BE36;font-weight: bold">{{total}}</span>
        </div>
        <div class="it search-wrap" style="padding: 1rem">
          <Input
            style
            v-model="num"
            placeholder="手动输入溯源码查询"
            size="large"
            class="input-box"
          />
          <div @click="search" class="btn">搜索</div>
        </div>
        <a
          href="javascript:0;"
          v-if="loginShow"
          @click="scanQRCode()"
          style="margin-left: 35%;color:#45b035;    font-size: 17px;"
        >
          <i class="iconfont iconsaoma"></i> 扫码搜索
        </a>
      </div>
    </div>
    <cp-footer></cp-footer>
    <!-- <div class="fixed-footer">
      <div class="list">
        <a href="https://pub.zym.so/">
          <i class="icon-search"></i>
          <span>溯源查询</span>
        </a>
        <a href="https://qx.gov.zym.so/">
          <i class="icon-text"></i>
          <span>资讯平台</span>
        </a>
      </div>
    </div>-->
  </div>
</template>

<script>
import cpFooter from "@/views/footer";
import { searchs } from "@/api/api";
import { getticket } from "@/api/bapi";
import { saveSuyuanRecord } from "@/api/bapi";

import { constants } from "fs";

export default {
  name: "Search",
  components: {
    cpFooter
  },
  data() {
    return {
      loginShow: false,
      menu_show: false,
      menu_show1: false,
      num: "", // 2018010060000000749368  4301210000020000000001 // BUovRazCj7Woh
      total: "",
      selectedLabelDefault: "首页",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      items: [
        {
          url: "",
          image: ""
        }
      ]
    };
  },
  computed: {
    httpUrl() {
      return this.$store.state.httpUrl;
    }
  },
  watch: {},
  created() {
    this.getTotal();
    // console.log('2018010060000000749368')
    // console.log((new Date().getFullYear() + parseInt(this.$route.params.years)) + '!')
    // console.log('params',this.$route.params.num)
    this.testCode();
  },
  methods: {
    save() {
      let uer = {
        zymCode: this.num,
        sysSource: 1
      };
      this.$axios({
        method: "post",
        url: "/portal/suyuan/saveSuyuanRecord",
        data: uer,
        headers: {
          // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token'),
          "Content-Type": "application/json"
        }
      })
        .then(res => {})
        .catch(function(reason) {});
    },
    wxLogin() {
      window.location = this.httpUrl + "/portal/webchat/login";
    },
    scanQRCode() {
      var u = navigator.userAgent;
      let vue = this;
      if (u.indexOf("Mac OS X") > 0 && u.indexOf("MicroMessenger") > 0) {
        wx.scanQRCode({
          // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
          needResult: 1,
          desc: "scanQRCode desc",
          success: function(res) {
            //扫码后获取结果参数赋值给Input
            var url = res.resultStr;
            //商品条形码，取","后面的
            if (url.indexOf(",") >= 0) {
              var tempArray = url.split(",");
              var tempNum = tempArray[1];
              vue.num = tempNum;
            } else {
              vue.num = url;
            }
            if (vue.num.indexOf("=") > 0) {
              vue.num = vue.num.substr(
                vue.num.indexOf("=") + 1,
                vue.num.length - vue.num.indexOf("=") - 1
              );
            } else {
              let list = vue.num.split("/");
              let val = list[list.length - 1];
              var regPos = /^\d+(\.\d+)?$/; //非负浮点数
              var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
              if (regPos.test(val) && regNeg.test(val)) {
                vue.num = val;
              } else {
                vue
                  .$axios({
                    method: "get",
                    url: "portal/suyuanChannel/getNum/" + list[list.length - 1]
                  })
                  .then(res => {
                    if (res.data.code == 1) {
                      vue.num = res.data.msg;
                    } else {
                      alert(res.data.msg);
                    }
                  })
                  .catch(err => {
                    console.log(err);
                  });
              }
            }
          }
        });
      } else if (u.indexOf("Mac OS X") < 0 && u.indexOf("MicroMessenger") > 0) {
        let vurl = window.location.href;
        let product = this.product;
        var link = vurl;
        getticket({ url: vurl })
          .then(rsp => {
            let wxconfig = rsp.data.data;
            wx.config({
              debug: false,
              appId: wxconfig.appId,
              timestamp: parseInt(wxconfig.timestamp),
              nonceStr: wxconfig.noncestr,
              signature: wxconfig.signature,
              jsApiList: ["scanQRCode"]
            });
            wx.ready(function() {
              wx.scanQRCode({
                // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
                needResult: 1,
                desc: "scanQRCode desc",
                success: function(res) {
                  //扫码后获取结果参数赋值给Input
                  var url = res.resultStr;
                  //商品条形码，取","后面的
                  if (url.indexOf(",") >= 0) {
                    var tempArray = url.split(",");
                    var tempNum = tempArray[1];
                    vue.num = tempNum;
                  } else {
                    vue.num = url;
                  }
                  if (vue.num.indexOf("=") > 0) {
                    vue.num = vue.num.substr(
                      vue.num.indexOf("=") + 1,
                      vue.num.length - vue.num.indexOf("=") - 1
                    );
                  } else {
                    let list = vue.num.split("/");
                    let val = list[list.length - 1];
                    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
                    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
                    if (regPos.test(val) && regNeg.test(val)) {
                      vue.num = val;
                    } else {
                      vue
                        .$axios({
                          method: "get",
                          url:
                            "portal/suyuanChannel/getNum/" +
                            list[list.length - 1]
                        })
                        .then(res => {
                          if (res.data.code == 1) {
                            vue.num = res.data.msg;
                          } else {
                            alert(res.data.msg);
                          }
                        })
                        .catch(err => {
                          console.log(err);
                        });
                    }
                  }
                }
              });
            });
            wx.error(function(res) {
              alert(JSON.stringify(res));
            });
          })
          .catch(rsp => {
            console.log(rsp);
          });
      }
    },

    testCode() {
      let qrCode = "";
      if (this.$route.params.num) {
        qrCode = this.$route.params.num;
      } else if (this.$route.query.q) {
        qrCode = this.$route.query.q;
      }
      if (qrCode != "") {
        let isNum = new RegExp("^[0-9]*$").test(qrCode);
        if (isNum) {
          this.num = qrCode;
          this.search();
        } else {
          this.$axios({
            method: "get",
            url: "portal/suyuanChannel/getNum/" + qrCode
          })
            .then(res => {
              if (res.data.code == 1) {
                this.num = res.data.msg;
              } else {
                alert(res.data.msg);
              }
            })
            .catch(err => {
              console.log(err);
            });

          this.$axios({
            method: "get",
            url: "portal/suyuanChannel/scan/" + qrCode
          })
            .then(res => {
              if (res.data.code == 0) {
                this.num = res.data.data.zymCode;
                // console.log('search', res.data)
                localStorage.setItem("zymCode", res.data.data.zymCode);
                localStorage.setItem("orgId", res.data.data.orgId);
                localStorage.setItem("suyuanCount", res.data.data.suyuanCount);
                this.save();
                this.$router.push({ name: "Common_product" });
              } else {
                alert(res.data.msg);
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    },
    getTotal() {
      this.loginShow = false;
      var u = navigator.userAgent;
      let vue = this;
      if (u.indexOf("MicroMessenger") > 0) {
        this.loginShow = true;
      }

      this.$axios({
        method: "get",
        url: "portal/suyuan/getSuyuanSumTotal"
      })
        .then(res => {
          console.log(res);
          if (res.data.code == 0) {
            this.total = res.data.data;
          } else {
            alert(res.data.msg);
          }
        })
        .catch(err => {});
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    },
    showmenu() {
      if (this.menu_show == true) {
        this.menu_show = false;
      } else if (this.menu_show == false) {
        this.menu_show = true;
      }
    },
    showmenu1() {
      if (this.menu_show1 == true) {
        this.menu_show1 = false;
      } else if (this.menu_show1 == false) {
        this.menu_show1 = true;
      }
    },
    //根据模版id
    search() {
      if(this.num == '')
      {
        this.$message.warning('真源码不能为空！');
        return;
      }
      if (this.num.indexOf("http") >= 0) {
        let qrCode = "";
        let list = this.num.split("/");
        qrCode = list[list.length - 1];
        if (qrCode != "") {
          let isNum = new RegExp("^[0-9]*$").test(qrCode);
          if (isNum) {
            this.num = qrCode;
            this.search();
          } else {
            this.$axios({
              method: "get",
              url: "portal/suyuanChannel/getNum/" + qrCode
            })
              .then(res => {
                if (res.data.code == 1) {
                  this.num = res.data.msg;
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(err => {
                console.log(err);
              });

            this.$axios({
              method: "get",
              url: "portal/suyuanChannel/scan/" + qrCode
            })
              .then(res => {
                if (res.data.code == 0) {
                  this.num = res.data.data.zymCode;
                  // console.log('search', res.data)
                  localStorage.setItem("zymCode", res.data.data.zymCode);
                  localStorage.setItem("orgId", res.data.data.orgId);
                  localStorage.setItem(
                    "suyuanCount",
                    res.data.data.suyuanCount
                  );
                  this.save();
                  this.$router.push({ name: "Common_product" });
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        }
      } else {
        this.$axios({
          method: "get",
          url: "portal/suyuanChannel/qeury/" + this.num
        })
          .then(res => {
            if (res.data.code == 0) {
              // console.log('search', res.data)
              localStorage.setItem("zymCode", this.num);
              localStorage.setItem("orgId", res.data.data.orgId);
              localStorage.setItem("suyuanCount", res.data.data.suyuanCount);
              this.save();
              this.$router.push({ name: "Common_product" });
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/css/rem.scss";
/deep/ .ivu-input {
  border: 1px solid #009237 !important;
  border-radius: 0px;
}
/deep/ .ivu-input-search {
  background: #45b035 !important;
}
* {
  padding: 0;
  margin: 0;
}
.container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background: url("../assets/h5bg1.jpg") center; */
  /* background-size: 100% 100%; */
}
.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  /* background-color: #f5f5f5; */
}
.header {
  position: fixed;
  left: 0px;
  top: 0px;
  background: #45b035;
  width: 100%;
  padding: 0 .8rem;
  // height: 2rem;
  /*height: 2.8rem;*/
}
.logo {
      width: 150px;
      margin-left: 20px;
  /*line-height: 3rem;*/
}
.logo img {
  width: 100%;
  margin: 10px 0 10px 20px;
}
.tab {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid #f1ebeb;
  background-color: white;
}
.nav {
  list-style: none;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1ebeb;
  background-color: white;
}
.nav a {
  color: #333333;
}
.nav li {
  width: 33%;
  padding: 10px 0;
}
.nav li:hover {
  color: #45b035;
}
.current a {
  color: #45b035;
}
.banner img {
  width: 100%;
}
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #999999;
  padding: 0rem 1rem;
  background-color: white;
  margin: 0 0.5rem;
  padding: 0.8rem;
  border-radius: 6px;
  z-index: 1;
  position: relative;
  top: -20px;
}
.introduce p {
  margin-bottom: 0.5rem;
}
.store {
  background-color: white;
  padding: 0.8rem;
}
h3 {
  font-size: 0.9rem;
  text-align: left;
  position: relative;
  padding-left: 10px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 10px;
}
h3:before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: 3px;
  height: 16px;
  background-color: #45b035;
}
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
  margin-top: 10px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}

.scan-btn {
}
.img_content img {
  border-radius: 6px;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}
.img {
  width: 100%;
  text-align: center;
}
.img img {
  width: 70%;
}
.name {
  /* text-shadow: 2px 0px 30px rgb(21, 89, 42); */
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 1rem;
  color: #009237;
}
.wz > span {
  color: #009237;
}
.footer {
  display: block;
  margin-top: 40px;
  text-align: center;
  border-top: 8px solid #45b035;

}
.footer p {
  font-size: 14px;
}
.footer p > a {
  color: #45b035;
}
.pcfooter {
  display: none;
}
.ct {
  width: 88%;
  margin: 21% auto 8% auto;
  min-height: 24rem;
  // height: calc(84% - 2.53333rem - 3.73333rem);//calc(84% - 95px - 140px);//2.53333rem 3.73333rem
}
// @media screen and (min-width: 1000px) {
//   .pcfooter {
//     display: block !important;
//   }
//   .footer {
//     display: none;
//   }
//   .container {
//     //background: url("../assets/bg1.jpg") center no-repeat;
//     //background-size: 100% 100%;
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//   }
//   // .top {
//   //   height: 2rem;
//   //   position: fixed;
//   //   left: 0px;
//   //   top: 0px;
//   //   width: 100%;
//   // }
//   .logo {
//     width: 150px;
//     margin-left: 20px;
//   }
//   .img {
//     width: 40%;
//     margin: 0 auto;
//   }
//   .img img {
//     width: 80%;
//   }
//   .ct {
//     display: flex;
//     justify-content: space-around;
//     min-height: 550px;
//   }
//   .rt {
//     width: 60%;
//   }
//   .name {
//     font-size: 1rem;
//   }
//   .wz {
//     margin-top: 0.7rem !important;
//   }
//   .it {
//     margin-top: 0.8rem !important;
//   }
//   // .qh {
//   //   display: block;
//   // }
// }

.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid #f2f2f2;
  background-color: #fff;
}
.fixed-footer .list {
  display: flex;
  align-content: space-between;
  margin: 0;
  padding: 0;
}
.fixed-footer .list a {
  flex: 1;
  text-align: center;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  color: #45b035;
}
.fixed-footer .list a i {
  position: relative;
  top: 4px;
  display: inline-block;
  width: 20px;
  height: 20px;
}
.fixed-footer .list a i.icon-search {
  background: url("https://image.cnhnb.com/zym%E6%90%9C%E7%B4%A2.png") no-repeat;
  background-size: 100%;
}
.fixed-footer .list a i.icon-text {
  background: url("https://image.cnhnb.com/zym%E8%B5%84%E8%AE%AF.png") no-repeat;
  background-size: 100%;
}
  /deep/ .footer {
    padding-bottom: 61px !important;
  }
  .search-wrap{
    overflow: hidden;
  }
  .search-wrap .input-box{
    width:87%;
    float: left;
  }
  .search-wrap .btn{
    width: 13%;
    height: 36px;
    float: left;
    font-size: 18px;
    line-height: 36px;
    background: #009237;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue